export default __webpack_public_path__ + "static/media/login-page.38bf3464.svg";